import { apiFetch } from './client';

/** One garment on a body slot (replaces free flat-lay placement). */
export interface ComposeItem {
  slot: string;
  cloth_id: string;
  id_type: 'cloth' | 'item';
  name: string;
  category: string;
  thumb: string;
  offset_x: number;
  offset_y: number;
  scale: number;
  z_index: number;
  // legacy optional
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  rotation?: number;
}

export interface ComposeRecord {
  id: string;
  virtual_user_id: string;
  author_username: string;
  title: string;
  description: string;
  tags: string[];
  thumbnail_url: string;
  query?: string;
  items: ComposeItem[];
  status: string;
  created_at: string;
  updated_at: string;
}

export interface CreateComposeRequest {
  virtual_user_id: string;
  title: string;
  description: string;
  tags: string[];
  thumbnail_url: string;
  query?: string;
  items: ComposeItem[];
}

export async function createCompose(req: CreateComposeRequest): Promise<{ id: string }> {
  return apiFetch('/v1/composes', { method: 'POST', body: JSON.stringify(req) });
}

export async function listComposes(params?: {
  virtual_user_id?: string;
  author?: string;
  limit?: number;
  offset?: number;
}): Promise<{ items: ComposeRecord[] }> {
  const qs = new URLSearchParams();
  if (params?.virtual_user_id) qs.set('virtual_user_id', params.virtual_user_id);
  if (params?.author) qs.set('author', params.author);
  if (params?.limit !== undefined) qs.set('limit', String(params.limit));
  if (params?.offset !== undefined) qs.set('offset', String(params.offset));
  return apiFetch(`/v1/composes?${qs.toString()}`);
}

export async function getCompose(id: string): Promise<ComposeRecord> {
  return apiFetch(`/v1/composes/${encodeURIComponent(id)}`);
}

export async function updateCompose(id: string, req: CreateComposeRequest): Promise<{ id: string }> {
  return apiFetch(`/v1/composes/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(req) });
}

export async function deleteCompose(id: string): Promise<{ ok: boolean }> {
  return apiFetch(`/v1/composes/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export const DRESS_SLOTS = [
  { id: 'tops', label: '上装' },
  { id: 'bottoms', label: '下装' },
  { id: 'dresses', label: '连衣裙' },
  { id: 'footwear', label: '鞋履' },
  { id: 'accessories', label: '配饰' },
  { id: 'bags', label: '包袋' },
  { id: 'jewelry', label: '珠宝' },
] as const;
